import * as React from 'react'
import { connect } from 'react-redux'
import { routerActions, RouterAction } from 'react-router-redux'
import '../styles/App.scss'
import '../styles/PublishedJob.scss'
import { ListItem } from 'material-ui/List'
import { FlatButton } from 'material-ui'
import { AppBarContainer } from './CustomAppBar'
import * as moment from 'moment'
import ApiError from '../Errors/ApiError'
import { Api } from '../services/api/api'
import JobUtils from '../utils/JobUtils'
import {
    setPublishedJobParams,
    setJobId,
    setJobStatus,
    removeJobDetails,
    setOriginatedFrom
} from '../actions/setJobDetails'
import {
    JobItems,
    AttachmentParams,
    PublishedJobParams,
    Job,
    AddressInfo,
    Slots,
    JobRequestStatus,
    NetworkErrorCode
} from '../types'
import images from '../images'
import PageTitle from '../components/PageTitle'
import JobItemDetails from '../components/JobItemDetails'
import FormattedAddress from '../components/FormattedAddress'
import { ROUTES } from '../constants/routes'
import { JobCategoryNames } from '../constants/jobCategoryNames'
import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import UploadedImages from '../components/UploadedImages'

import Lightbox from 'react-images-zoom'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'

import { StickyContainer, Sticky } from 'react-sticky'
import { CustomTextarea } from '../components/CustomTextarea'

import {
    ActionType as ErrorInfoActionType,
    Actions as ErrorActions
} from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import { getFormatedPrice } from '../utils/PricingUtils'
import { PaymentInfoRequiredDialog } from '../components/PaymentInfoRequiredDialog'
import { RouteComponentProps } from 'react-router'
import { History } from 'history'
import LocationDescriptor = History.LocationDescriptor

interface PublishedJobProps {
    pathname: string
    timeStopBidding?: number
    address: any
    jobDetails: any
    stripeAccount: string
    jobItems: JobItems[]
    jobCategoryName: string
    futureDateFrom: number
    futureDateTo: number
    publishedJobParams: PublishedJobParams
    amount: number
    files: Array<any>
    jobRequestId?: string

    routePush: (location: LocationDescriptor) => RouterAction
    onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
    onSetJobId: (jobId: string) => void
    onPublishedJobParams: (publishedJobParams: PublishedJobParams) => void
    onSetJobStatus: (status: string) => void
    onRemoveJobDetails: () => void
    onSetOriginatedFrom: (id: string) => void
}

interface PublishedJobState {
    confirmed: boolean
    jobCategoryName: string
    isTimerShown: boolean
    jobId: string
    status: string
    isDialogOpen: boolean
    isTimeExpired: boolean
    isErrorDialogOpen: boolean
    errorTitle: string
    interval?: any
    isJobAccepted: boolean
    isButtonDisabled: boolean
    photoIndex: number
    isImagesBoxOpen: boolean
    isPaymentInfoDialogOpen: boolean
}

type Props = PublishedJobProps & RouteComponentProps<any>

class PublishedJobComponent extends React.Component<Props, PublishedJobState> {
    constructor(props: Props) {
        super(props)
        this.state = {
            confirmed: this.props.publishedJobParams.confirmed,
            jobCategoryName: this.props.jobCategoryName
                ? this.props.jobCategoryName
                : '',
            isTimerShown:
                this.props.publishedJobParams.timeKeeping !== 0 ? true : false,
            jobId: this.props.jobDetails.jobId,
            status: this.props.jobDetails.status,
            isDialogOpen: false,
            isTimeExpired: false,
            isErrorDialogOpen: false,
            errorTitle: '',
            isJobAccepted: false,
            isButtonDisabled: false,
            photoIndex: 0,
            isImagesBoxOpen: false,
            isPaymentInfoDialogOpen: false
        }
    }

    componentDidMount() {
        if (this.props.jobRequestId) {
            // tslint:disable-next-line: no-floating-promises
            Api.updateJobRequest(this.props.jobRequestId, {
                status: JobRequestStatus.AT_REVIEW_JOB_DETAILS
            })
        }
        if (this.props.jobDetails.status && this.props.jobDetails.status) {
            this.setState({
                isButtonDisabled: true
            })
        }
    }

    postJob = () => {
        const prototype = this.props.jobDetails
        const { jobRequestId } = this.props
        let countable =
            prototype.jobCategories[prototype.selectedJobCategory].countable
        let startTime = moment().valueOf()
        // console.log(prototype)
        let job = {
            id: jobRequestId || JobUtils.guid(),
            clientId: '1234',
            name: 'client1995',
            status: 'CREATED',
            clientStatus: '',
            haulerStatus: '',
            attachments: !countable ? prototype.attachments : [],
            jobCategoryId: prototype.jobCategoryId,
            msaId: prototype.msaId,
            coordinates: prototype.coordinates,
            note: prototype.note,
            amount: countable ? prototype.amount : null,
            address: prototype.address,
            apartmentNumber: prototype.apartmentNumber,
            futureDateFrom: prototype.futureDateFrom,
            futureDateTo: prototype.futureDateTo,
            modifyDate: moment.utc().valueOf(),
            areItemsOutside: prototype.areItemsOutside,
            areItemsInside: prototype.areItemsInside,
            isElevatorNeeded: prototype.isElevatorNeeded,
            areStairsNeeded: prototype.areStairsNeeded,
            cancelReason: '',
            // createDate: moment.utc().valueOf(),
            jobItems: countable ? prototype.jobItems : [],
            zip: prototype.zipCode,
            timeSlots: prototype.slots,
            jobRequestId
        }

        this.setState({
            isButtonDisabled: true
        })

        Api.newJob(job)
            .then((newJob: Job) => {
                let imgs = prototype.attachments
                if (imgs && imgs.length > 0) {
                    for (let i = 0; i < imgs.length; i++) {
                        Api.setOwnerId(imgs[i], newJob.id)
                            .then(res =>
                                console.log('imgs attached successfully', res)
                            )
                            .catch(err => {
                                console.log('error when setting OwnerId:', err)
                                this.props.onErrorEvent(Mapper.mapError(err))
                                return
                            })
                    }
                }

                if (this.props.jobRequestId) {
                    Api.deleteJobRequest(this.props.jobRequestId)
                }

                this.processNewJob(newJob, startTime)
            })
            .catch(error => {
                console.log(error, 'Cannot publish job')
                this.trackErrorOnJobRequest(job.id, error)
                this.props.onErrorEvent(Mapper.mapError(error))
            })
    }

    trackErrorOnJobRequest = (id: string, error: any) => {
        const error2 = Mapper.mapError(error)
        console.log(error2)
        if (error2) {
            switch (error2.code) {
                case NetworkErrorCode.NO_ACTIVE_PROVIDERS_IN_SELECTED_MSA:
                    // tslint:disable-next-line: no-floating-promises
                    Api.updateJobRequest(id, {
                        status: JobRequestStatus.NO_REGISTERED_HAULERS_FOR_MSA
                    })
                    break
                case NetworkErrorCode.CLIENT_PAYMENT_ACCOUNT_NOT_FOUND:
                    // tslint:disable-next-line: no-floating-promises
                    Api.updateJobRequest(id, {
                        status: JobRequestStatus.MISSING_CC_INFO
                    })
                    break
                case NetworkErrorCode.CLIENT_INVALID_CHARGE_ACCOUNT:
                    // tslint:disable-next-line: no-floating-promises
                    Api.updateJobRequest(id, {
                        status: JobRequestStatus.MISSING_CC_INFO
                    })
                    break
                case NetworkErrorCode.CLIENT_ALREADY_HAS_ACTIVE_JOB:
                    // tslint:disable-next-line: no-floating-promises
                    Api.updateJobRequest(id, {
                        status: JobRequestStatus.UNKNOWN_ERROR
                    })
                    break
                default:
                    break
            }
        }
    }

    repostJob = () => {
        let startTime = moment().valueOf()
        this.setState({ isButtonDisabled: true })

        Api.repostJob(this.props.jobDetails.jobId, this.props.jobDetails.slots)
            .then((newJob: Job) => {
                this.processNewJob(newJob, startTime)
            })
            .catch(error => {
                console.log(error, 'Cannot repost job')
                this.props.onErrorEvent(Mapper.mapError(error))
            })
    }

    processNewJob = (newJob, startTime) => {
        let requestTime = moment().valueOf() - startTime

        let hours = Math.floor(newJob.timeKeeping / 3600000)
        let minutes = Math.floor((newJob.timeKeeping - hours * 3600000) / 60000)
        let seconds = Math.floor(
            (newJob.timeKeeping - minutes * 60000 - hours * 3600000) / 1000
        )

        if (minutes >= 1) {
            if (seconds >= requestTime) {
                seconds = seconds - Math.round(requestTime / 1000)
            } else {
                minutes = minutes - 1
                seconds = seconds + 60 - Math.round(requestTime / 1000)
            }
        }

        let publishedJobParams = {
            confirmed: this.state.confirmed,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            createDate: newJob.createDate,
            timeKeeping: newJob.timeKeeping,
            timeStopBidding: newJob.timeStopBidding,
            secondTimeKeeping: 0,
            biddingActiveDate: 0
        }

        this.props.onSetJobId(newJob.id)
        this.props.onPublishedJobParams(publishedJobParams)
        this.props.onSetJobStatus(newJob.status)
        this.props.onSetOriginatedFrom(newJob.originatedFrom)
        this.setState({
            jobId: newJob.id
        })

        this.props.routePush(ROUTES.VIEW_BIDS)
    }

    handleConfirm = () => {
        if (this.props.location.state && this.props.location.state['repost']) {
            this.repostJob()
        } else this.postJob()
    }

    goBack = () => {
        history.back()
    }

    onViewBidsClick = () => {
        if (!!this.props.stripeAccount) {
            this.handleConfirm()
        } else {
            this.setState({
                isPaymentInfoDialogOpen: true
            })
        }
    }

    handleDialogOpen = () => {
        this.setState({
            isDialogOpen: true
        })
    }

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false
        })
    }

    handleTimeExpired = () => {
        this.setState({
            isTimeExpired: true,
            isErrorDialogOpen: true,
            errorTitle: 'The job has expired.'
        })
    }

    handleErrorDialogClose = (e: any) => {
        this.setState({
            isErrorDialogOpen: false
        })
        this.props.routePush(ROUTES.PICKUP_LOCATION)
    }

    handleIconClick = (event: any) => {
        // tslint:disable-next-line:radix
        let iconIndex = parseInt(event.target.id)
        this.handleImageClick(iconIndex)
    }

    handleImageClick = (iconIndex: number) => {
        this.setState({ photoIndex: iconIndex, isImagesBoxOpen: true })
    }

    handlePaymentInfoDialogClose = (success: boolean) => {
        this.setState({
            isPaymentInfoDialogOpen: false
        })

        if (success) this.handleConfirm()
    }

    getDays = () => {
        let slots: Slots[] = this.props.jobDetails.slots
        let days: Slots[] = []
        let sortedSlots = slots.sort((a, b) => {
            return (
                moment(a.dateFrom).month() - moment(b.dateFrom).month() ||
                moment(a.dateFrom).date() - moment(b.dateFrom).date() ||
                moment(a.dateFrom).hour() - moment(b.dateFrom).hour()
            )
        })
        let i: number
        let length = slots.length

        for (i = 0; i < length; i++) {
            if (
                days.find(
                    item =>
                        moment(item.dateFrom).date() ===
                        moment(slots[i].dateFrom).date()
                ) === undefined
            ) {
                days.push(slots[i])
            }
        }

        return sortedSlots.map((day, index) => {
            if (
                sortedSlots[index + 1] === undefined ||
                (sortedSlots[index + 1] &&
                    moment(sortedSlots[index].dateFrom).date() !==
                        moment(sortedSlots[index + 1].dateFrom).date())
            ) {
                return (
                    <li key={index}>
                        <span className="dates">
                            {moment(day.dateFrom).date() === moment().date()
                                ? 'Today: '
                                : moment(day.dateFrom).format('MMMM D: ')}
                        </span>
                        <span>
                            {sortedSlots.map(
                                (dateAndTime: Slots, index: number) => {
                                    const timeFrom =
                                        moment(dateAndTime.dateFrom).hours() %
                                        12
                                    const timeTo = moment(
                                        dateAndTime.dateTo
                                    ).hours()

                                    const timeFromLabel = dateAndTime.isNow
                                        ? 'Now'
                                        : `${timeFrom}`

                                    if (
                                        moment(day.dateFrom).date() ===
                                        moment(dateAndTime.dateFrom).date()
                                    ) {
                                        const label = `${timeFromLabel} - ${
                                            timeTo > 12 ? timeTo - 12 : timeTo
                                        }${timeTo > 12 ? 'pm' : 'am'}`
                                        if (
                                            sortedSlots[index + 1] &&
                                            moment(day.dateFrom).date() ===
                                                moment(
                                                    sortedSlots[index + 1]
                                                        .dateFrom
                                                ).date()
                                        ) {
                                            return `${label}, `
                                        }
                                        return label
                                    }
                                }
                            )}
                        </span>
                    </li>
                )
            }
        })
    }

    render() {
        let countable =
            this.props.jobDetails.jobCategories.length !== 0 &&
            this.props.jobDetails.selectedJobCategory &&
            this.props.jobDetails.jobCategories[
                this.props.jobDetails.selectedJobCategory
            ].countable

        let jobItems = this.props.jobItems

        let imgSrcs =
            this.props.files &&
            this.props.files.map(file => {
                return { src: file.base64 }
            })

        return (
            <BaseContainer pageName={EventType.PUBLISHED_JOB}>
                <Lightbox
                    images={imgSrcs ? imgSrcs : []}
                    currentImage={this.state.photoIndex}
                    showImageCount={true}
                    isOpen={this.state.isImagesBoxOpen}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClickPrev={() => {
                        this.setState({
                            photoIndex:
                                (this.state.photoIndex +
                                    this.props.files.length -
                                    1) %
                                this.props.files.length
                        })
                    }}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClickNext={() => {
                        this.setState({
                            photoIndex:
                                (this.state.photoIndex + 1) %
                                this.props.files.length
                        })
                    }}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClose={() => {
                        this.setState({ isImagesBoxOpen: false })
                    }}
                    rotatable={true}
                    zoomable={true}
                />
                <AppBarContainer
                    isIconButtonsShown={true}
                    isMenuShown={false}
                />
                <PageTitle
                    text={
                        this.state.confirmed
                            ? StringResources.getString(
                                  Strings.PublishedJob.Titles.JobPublished
                              )
                            : StringResources.getString(
                                  Strings.PublishedJob.Titles.ReviewJobDetails
                              )
                    }
                />
                <PerfectScrollbar className="completed-job-scrollbar">
                    <div className="job-details-list">
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="map-icon"
                                    src={images.pickupLocation}
                                />
                            }
                            primaryText={StringResources.getString(
                                Strings.PublishedJob.Items.Location.Text
                            )}
                            secondaryText={
                                <div>
                                    <FormattedAddress
                                        address={this.props.jobDetails.address}
                                    />
                                </div>
                            }
                            secondaryTextLines={2}
                        />
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="job-icon"
                                    src={
                                        this.state.jobCategoryName ===
                                        JobCategoryNames.QUICK_HAUL
                                            ? images.quickHaul
                                            : this.state.jobCategoryName ===
                                              JobCategoryNames.YARD_DEBRIS
                                            ? images.yardDebris
                                            : this.state.jobCategoryName ===
                                              JobCategoryNames.JUNK
                                            ? images.junk
                                            : this.state.jobCategoryName ===
                                              JobCategoryNames.RECYCLE
                                            ? images.recycle
                                            : images.quickHaul
                                    }
                                />
                            }
                            primaryText={this.state.jobCategoryName}
                            secondaryText={
                                countable ? (
                                    <p>
                                        <span>
                                            {jobItems &&
                                                jobItems.map((item, index) => {
                                                    return `${
                                                        item.count === 0
                                                            ? ''
                                                            : `${item.count} ${item.subCategoryId}`
                                                    }
                            ${
                                item.count !== 0 &&
                                jobItems[index + 1] &&
                                jobItems[index + 1].count !== 0
                                    ? ', '
                                    : ''
                            } `
                                                })}
                                        </span>{' '}
                                        <br />
                                        <span>
                                            {`${StringResources.getString(
                                                Strings.PublishedJob.Items
                                                    .Amount.SecondaryText
                                            )}${getFormatedPrice(
                                                this.props.amount
                                            )}`}
                                        </span>
                                    </p>
                                ) : (
                                    <p>
                                        <br />
                                    </p>
                                )
                            }
                            secondaryTextLines={2}
                        />
                        <ListItem
                            className="job-details-list-item dates-times-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="calendar-icon-published"
                                    src={images.calendar}
                                />
                            }
                            primaryText={StringResources.getString(
                                Strings.PublishedJob.Items.Time.Text
                            )}
                            secondaryText={
                                <div>
                                    {
                                        <ul className="dates-and-times">
                                            {this.getDays()}
                                        </ul>
                                    }
                                </div>
                            }
                            secondaryTextLines={2}
                        />
                        {!countable ? (
                            <div className="uploaded_img">
                                {this.props.files &&
                                    this.props.files.map(
                                        (
                                            file: AttachmentParams,
                                            index: number
                                        ) => (
                                            <UploadedImages
                                                key={file.id}
                                                handleIconClick={
                                                    this.handleIconClick
                                                }
                                                file={file}
                                                index={index}
                                                isBadgeNeeded={false}
                                            />
                                        )
                                    )}
                            </div>
                        ) : null}
                        {
                            <div>
                                <JobItemDetails
                                    isElevatorNeeded={
                                        this.props.jobDetails.isElevatorNeeded
                                            ? true
                                            : false
                                    }
                                    areItemsOutside={
                                        this.props.jobDetails.areItemsOutside
                                            ? true
                                            : false
                                    }
                                    areItemsInside={
                                        this.props.jobDetails.areItemsInside
                                            ? true
                                            : false
                                    }
                                    areStairsNeeded={
                                        this.props.jobDetails.areStairsNeeded
                                            ? true
                                            : false
                                    }
                                    pathname={this.props.pathname}
                                />
                                {this.props.jobDetails.note ? (
                                    <CustomTextarea
                                        classes="published-client-comment"
                                        text={this.props.jobDetails.note}
                                    >
                                        {this.props.jobDetails.note}
                                    </CustomTextarea>
                                ) : null}
                                <div className="title bids">
                                    {StringResources.getString(
                                        Strings.PublishedJob.SubTitles.Confirm
                                    )}
                                </div>
                                <ul className="hazardous-materials">
                                    <li className="icon">
                                        <img src={images.notHazardous} />
                                    </li>
                                    <li className="text">
                                        <p>
                                            {StringResources.getString(
                                                Strings.PublishedJob.Paragraphs
                                                    .Hazardous
                                            )}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        }
                    </div>
                </PerfectScrollbar>
                <StickyContainer
                    className={
                        this.props.jobDetails.minHeight > 85
                            ? 'sticky-footer'
                            : 'sticky-footer sb'
                    }
                >
                    <Sticky>
                        {() => (
                            <div className={'bottom-part hover'}>
                                <FlatButton
                                    label={StringResources.getString(
                                        Strings.PublishedJob.Buttons.Back.label
                                    )}
                                    className={
                                        this.state.isButtonDisabled
                                            ? 'flatbutton disabled'
                                            : 'flatbutton'
                                    }
                                    onClick={this.goBack}
                                    disabled={this.state.isButtonDisabled}
                                />
                                <FlatButton
                                    label={StringResources.getString(
                                        Strings.PublishedJob.Buttons.Publish
                                            .label
                                    )}
                                    className={
                                        this.state.isButtonDisabled
                                            ? 'flatbutton disabled'
                                            : 'flatbutton'
                                    }
                                    onClick={this.onViewBidsClick}
                                    disabled={this.state.isButtonDisabled}
                                />
                            </div>
                        )}
                    </Sticky>
                </StickyContainer>
                <PaymentInfoRequiredDialog
                    isDialogOpen={this.state.isPaymentInfoDialogOpen}
                    onClose={this.handlePaymentInfoDialogClose}
                />
            </BaseContainer>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        jobDetails: state.jobDetails,
        jobItems: state.jobDetails.jobItems,
        futureDateFrom: state.jobDetails.futureDateFrom,
        futureDateTo: state.jobDetails.futureDateTo,
        publishedJobParams: state.publishedJobParams,
        amount: state.jobDetails.amount,
        jobCategoryName: state.jobDetails.jobCategoryName,
        files: state.jobDetails.attachments,
        address: state.jobDetails.address,
        pathname: state.routing.location.pathname,
        stripeAccount: state.auth.user.stripeAccount,
        jobRequestId: state.currentJob ? state.currentJob.jobRequestId : null
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onPublishedJobParams: (publishedJobParams: PublishedJobParams) =>
            dispatch(setPublishedJobParams(publishedJobParams)),
        routePush: (location: LocationDescriptor) =>
            dispatch(routerActions.push(location)),
        onSetJobId: (jobId: string) => dispatch(setJobId(jobId)),
        onSetJobStatus: (status: string) => dispatch(setJobStatus(status)),
        onSetOriginatedFrom: (id: string) => dispatch(setOriginatedFrom(id)),
        onRemoveJobDetails: () => dispatch(removeJobDetails()),
        onErrorEvent: (errorInfo: ErrorInfo) =>
            dispatch(ErrorActions.newError(errorInfo))
    }
}

const PublishedJob = connect(
    mapStateToProps,
    mapDispatchToProps
)(PublishedJobComponent)

export default PublishedJob



// WEBPACK FOOTER //
// ./src/containers/PublishedJob.tsx